/* eslint-disable @typescript-eslint/no-unused-vars */

// runs perfectScrollbar (custom scrolling) plugin on the element
xplenty.directive('perfectScrollbar', [
  function () {
    return {
      restrict: 'A',

      link(scope, element, attrs) {
        element.perfectScrollbar();

        scope.$on('$destroy', function () {
          element.perfectScrollbar('destroy');
        });
      },
    };
  },
]);
